/// <reference types="datatables.net" />

import { Component, OnInit } from "@angular/core";
import { AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { ApiIntegration } from "../../_services/api.integration";
import { Globals } from "../../_models/globals";
import { DataTableDirective } from "angular-datatables";
//import {LocalStorageService,SessionStorageService,LocalStorage,SessionStorage,} from "angular-web-storage";
import { environment } from "../../../environments/environment";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { User } from "../../_models/user";
import { Address } from "../../_models/address";
import { Subject } from "rxjs";
import { Register } from "../../_models/register";
import { Caller } from "../../_models/caller";
import { Product } from "../../_models/product";
import { Contacts } from "../../_models/contacts";
import { Warehouse } from "../../_models/warehouse";
import { OrderLine } from "../../_models/orderLine";
import { KitComponent } from "../../_models/kitComponent";
import { AlertService } from "../../_services/alert.service";
import * as _ from "lodash";
import { StockLine } from "../../_models/stockLine";
import { StockShipmentLine } from "../../_models/stockShipmentLine";
import { DatePipe } from "@angular/common";
import { PayService } from "../../_services/pay.service";

@Component({
  selector: "app-create-orders",
  templateUrl: "./create-orders.component.html",
  styleUrls: ["./create-orders.component.css"],
  providers: [DatePipe],
})
export class CreateOrdersComponent implements OnInit {
  tabClicked = "addProducts";
  activeProduct: Product = {
    productName: "",
    productType: "",
    barCode: "",
    sku: "",
    storeSku: 0,
    dimensions: "",
    weight: 0,
    imageUrl: "",
    status: "",
    ownerName: "",
    createdBy: "",
    createdDate: "",
    updatedBy: "",
    updatedDate: "",
    accountOwnerId: 0,
    organizationId: 0,
    productId: 0,
    id: 0,
    kitComponents: 0,
  };
  activeProducts: Product[] = [];
  selectedProducts = [];
  actualQuantity: number;
  statesList: any;
  citiesList: any;
  contactSender: any;
  contactSenderZipcode: any;
  contactReceiver: any;
  orderAmountError: any;
  contactReceiverZipcode: any;
  accountOwner: any;
  orderAmount: any;
  senderNameAddressText: any;
  receiverNameAddressText: any;
  contactAddressText: any;
  newSenderPopup: string = "N";
  newReceiverPopup: string = "N";
  creditBalancePopup: string = "N";
  singleBoxWeightTemp: number;
  totalWeight: number = 0;
  totalWeightTemp: number = 0;
  packagesList = [];
  costEstimateList: any = {};
  costEstimation: any;
  boxHeights: number = 0;
  boxWidths: number = 0;
  boxLengths: number = 0;
  productHeight:string;
  productLength:string;
  productWidth:string;
  accountId: any;
  amount: any;
  amountError: any;
  razorPayData: any;
  receiverAddresses: Contacts[] = [];
  senderAddresses: Contacts[] = [];
  stockShipLine: StockShipmentLine = {};
  stockShipLines: Array<StockShipmentLine>;
  allShipLines: Array<StockShipmentLine>;
  stockLines: StockLine[] = [];
  stockLine: StockLine = {};
  configStockLine: StockLine = {};
  receiverName: any;
  senderName: any;
  shipType: any;
  newProductPopup: string = "N";
  senderContactName: string;
  senderCompanyName: string;
  senderNameError: string;
  receiverNameError: string;
  receiverContactName: string;
  receiverCompanyName: string;
  senderEmail: string;
  senderAddress1: string;
  senderCity: string;
  senderState: string;
  senderZip: string;
  paymentMode: string = "COD";
  receiverEmail: string;
  senderMobile: string;
  receiverMobile: string;
  receiverAddress1: string;
  receiverCity: string;
  receiverState: string;
  receiverZip: string;
  productName: string;
  weight: number;
  dimensions: string;
  sku: string;
  storeSku: string;
  hsnCode: string;
  price: string;
  taxRate: string;
  quantity: number;
  shipMethod: string = "PARCEL";
  productConfig: string;
  address: Contacts = {};
  package: any = [];
  shippingCost: any = [];
  step: number = 1;
  numberOfBoxesM: string;
  configLineIdSeq: number = 1;
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText7: string = "";
  statusText8: string = "";
  statusText9: string = "";
  statusText10: string = "";
  statusText11: string = "";
  statusText12: string = "";
  statusText13: string = "";
  statusText14: string = "";
  statusText15: string = "";
  statusText16: string = "";
  statusText17: string = "";
  statusText18: string = "";
  statusText19: string = "";
  statusText20: string = "";
  statusText21: string = "";
  statusText22: string = "";
  statusText23: string = "";
  statusText24: string = "";
  statusText25: string = "";
  statusText26: string = "";
  statusText27: string = "";
  statusText28: string = "";
  statusText29: string = "";
  statusText30: string = "";
  contact: Contacts = {};
  textVal: string;
  getCreditsAmount: any;
  setOfValues: any = [];
  others: boolean = false;
  othersDisplay: string;
  carrierName: string;
  shippedDate: string;
  shipmentCostOther: string;
  AWBNumber: string;
  trackingURL: string;
  carrierNameError: string;
  shippedDateError: string;
  shipmentCostOtherError: string;
  shipmentDateChange: string;

  constructor(
    private datePipe: DatePipe,
    private payService: PayService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private http: HttpClient,
    private router: Router,
    private api: ApiIntegration,
    private g: Globals,
    public user: User,
    public register: Register,
    public caller: Caller
  ) {
    this.g.page = "Create Order";
    this.getAOContactsBySender();
  }

  getProducts() {
    if (this.user.role == "ROLE_ADMIN") {
      this.accountId = this.accountOwner;
    } else {
      this.accountId = this.user.accountOwnerId;
    }
    this.api.getProductsList(this.accountId, "1").subscribe(
      (data: any) => {
        this.activeProducts = data.getProductsResponses;
      },
      (err) => {
        console.log(err);
        this.alertService.error("Error", err);
      }
    );
  }

  getPackageType() {
    if (this.user.role == "ROLE_ADMIN") {
      this.api.getPackingTypesList("1").subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          this.package = data.getPackingTypesResponses;
          this.package.push({
            packingType: "Custom",
            height: "",
            width: "",
            length: "",
            weight: "",
          });
        },
        (err) => {
          this.g.loaderDisplay = "";
          console.log(err);
        }
      );
    } else if (this.user.role == "ACCOUNT_OWNER") {
      this.api
        .getPackingTypesListAccount(this.user.accountOwnerId, "1")
        .subscribe(
          (data: any) => {
            this.g.loaderDisplay = "";
            this.package = data.getPackingTypesResponses;
            this.package.push({
              packingType: "Custom",
              height: "",
              width: "",
              length: "",
              weight: "",
            });
          },
          (err) => {
            this.g.loaderDisplay = "";
            console.log(err);
          }
        );
    } else if (this.user.role == "AO_SELLER") {
      this.api.getPackingTypesListSeller(this.user.sellerId, "1").subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          this.package = data.getPackingTypesResponses;
          this.package.push({
            packingType: "Custom",
            height: "",
            width: "",
            length: "",
            weight: "",
          });
        },
        (err) => {
          this.g.loaderDisplay = "";
          console.log(err);
        }
      );
    }
  }

  getAOContactsBySender() {
    this.g.loaderDisplay = "display";
    if (this.user.role == "ROLE_ADMIN") {
      this.accountId = this.accountOwner;
    } else {
      this.accountId = this.user.accountOwnerId;
    }
    this.api
      .getContactsByCustomerType("1", this.accountId, "ACTIVE", "SENDER")
      .subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          this.contactSender = data.updateAOContactResponseList;
        },
        (err) => {
          console.log(err);
        }
      );
    this.getAOContactsByReceiver();
  }

  getAOContactsByReceiver() {
    this.g.loaderDisplay = "display";
    if (this.user.role == "ROLE_ADMIN") {
      this.accountId = this.accountOwner;
    } else {
      this.accountId = this.user.accountOwnerId;
    }
    this.api
      .getContactsByCustomerType("1", this.accountId, "ACTIVE", "RECEIVER")
      .subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          this.contactReceiver = data.updateAOContactResponseList;
        },
        (err) => {
          console.log(err);
        }
      );
    this.getProducts();
  }

  customSearchFn(term: string, item: any = []) {
    term = term.toLowerCase();
    return (
      item.contactName.toLowerCase().indexOf(term) > -1 ||
      (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1)
    );
  }

  recipientInformation() {
    this.step = 1;
  }

  backAddProducts() {
    this.step = 2;
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = "please enter carrierName";
    }
  }

  shippedDateBlur() {
    this.shippedDateError = "";
    if (!this.shippedDate) {
      this.shippedDateError = "please select shippedDate";
    }
  }

  shipmentCostOtherBlur() {
    this.shipmentCostOtherError = "";
    if (!this.shipmentCostOther) {
      this.shipmentCostOtherError = "please enter shipmentCost";
    }
  }

  tabChange(tab) {
    this.tabClicked = tab;
  }

  stateList() {
    this.api.getDistinctStates().subscribe(
      (data: any) => {
        this.statesList = data;
      },
      (err) => {
        this.alertService.error("Error", err);
      }
    );
  }

  cityList() {
    this.api.getDistinctCity().subscribe(
      (data: any) => {
        this.citiesList = data;
      },
      (err) => {
        this.alertService.error("Error", err);
      }
    );
  }

  changeCityAndState() {
    this.api.getCityAndStateByPinCode(this.address.zip).subscribe(
      (data: any) => {
        this.address.city = data.city;
        this.address.state = data.state;
      },
      (err) => {
        this.alertService.error("Error", err);
      }
    );
  }

  typeQuantity() {
    this.statusText18 = "";
    for (let r of this.stockLines) {
      if (
        r.actualQuantity === null ||
        r.actualQuantity === undefined ||
        r.actualQuantity <= 0
      ) {
        this.statusText18 = "Please enter quantity as minimum 1";
      }
    }
  }

  typeSenderName() {
    this.statusText1 = "";
    if (
      this.senderContactName == "" ||
      this.senderContactName === null ||
      this.senderContactName === undefined ||
      this.senderContactName === "undefined"
    ) {
      this.statusText1 = "Please enter Sender name";
    }
  }

  typeSenderEmail() {
    this.statusText2 = "";
    if (
      this.senderEmail == "" ||
      this.senderEmail === null ||
      this.senderEmail === undefined ||
      this.senderEmail === "undefined"
    ) {
      this.statusText2 = "Please enter Sender Email";
    }
  }

  typeSenderMobile() {
    this.statusText3 = "";
    if (
      this.senderMobile == "" ||
      this.senderMobile === null ||
      this.senderMobile === undefined ||
      this.senderMobile === "undefined"
    ) {
      this.statusText3 = "Please enter Sender Mobile number";
    }
  }

  typeSenderAddress1() {
    this.statusText4 = "";
    if (
      this.address.address1 == "" ||
      this.address.address1 === null ||
      this.address.address1 === undefined ||
      this.address.address1 === "undefined"
    ) {
      this.statusText4 = "Please enter Sender Address1";
    }
  }

  typeSenderCity() {
    this.statusText5 = "";
    if (
      this.address.city == "" ||
      this.address.city === null ||
      this.address.city === undefined ||
      this.address.city === "undefined"
    ) {
      this.statusText5 = "Please enter Sender City";
    }
  }

  typeSenderState() {
    this.statusText6 = "";
    if (
      this.address.state == "" ||
      this.address.state === null ||
      this.address.state === undefined ||
      this.address.state === "undefined"
    ) {
      this.statusText6 = "Please enter Sender State";
    }
  }

  typeSenderZip() {
    this.statusText7 = "";
    if (
      this.address.zip == "" ||
      this.address.zip === null ||
      this.address.zip === undefined ||
      this.address.zip === "undefined"
    ) {
      this.statusText7 = "Please enter Sender Zip";
    }
  }

  typeReceiverName() {
    this.statusText8 = "";
    if (
      this.receiverContactName == "" ||
      this.receiverContactName === null ||
      this.receiverContactName === undefined ||
      this.receiverContactName === "undefined"
    ) {
      this.statusText8 = "Please enter Receiver name";
    }
  }

  typeReceiverEmail() {
    this.statusText9 = "";
    if (
      this.receiverEmail == "" ||
      this.receiverEmail === null ||
      this.receiverEmail === undefined ||
      this.receiverEmail === "undefined"
    ) {
      this.statusText9 = "Please enter Receiver Email";
    }
  }

  typeReceiverMobile() {
    this.statusText10 = "";
    if (
      this.receiverMobile == "" ||
      this.receiverMobile === null ||
      this.receiverMobile === undefined ||
      this.receiverMobile === "undefined"
    ) {
      this.statusText10 = "Please enter Receiver Mobile number";
    }
  }

  typeReceiverAddress1() {
    this.statusText11 = "";
    if (
      this.address.address1 == "" ||
      this.address.address1 === null ||
      this.address.address1 === undefined ||
      this.address.address1 === "undefined"
    ) {
      this.statusText11 = "Please enter Receiver Address1";
    }
  }

  typeReceiverCity() {
    this.statusText12 = "";
    if (
      this.address.city == "" ||
      this.address.city === null ||
      this.address.city === undefined ||
      this.address.city === "undefined"
    ) {
      this.statusText12 = "Please enter Receiver City";
    }
  }

  typeReceiverState() {
    this.statusText13 = "";
    if (
      this.address.state == "" ||
      this.address.state === null ||
      this.address.state === undefined ||
      this.address.state === "undefined"
    ) {
      this.statusText13 = "Please enter Receiver State";
    }
  }

  typeReceiverZip() {
    this.statusText14 = "";
    if (
      this.address.zip == "" ||
      this.address.zip === null ||
      this.address.zip === undefined ||
      this.address.zip === "undefined"
    ) {
      this.statusText14 = "Please enter Receiver Zip";
    }
  }

  typeProduct() {
    this.statusText15 = "";
    if (
      this.productName == "" ||
      this.productName === null ||
      this.productName === undefined ||
      this.productName === "undefined"
    ) {
      this.statusText15 = "Please enter Product Name";
    }
  }

  typeStoreSKU() {
    this.statusText16 = "";
    if (
      this.storeSku == "" ||
      this.storeSku === null ||
      this.storeSku === undefined ||
      this.storeSku === "undefined"
    ) {
      this.statusText16 = "Please enter Store SKU";
    } else if (this.storeSku.length <= 3) {
      this.statusText16 = "Store SKU must contain atleast 3-50 characters";
    }
  }

  typeHsnCode() {
    this.statusText17 = "";
    if (
      this.hsnCode == "" ||
      this.hsnCode === null ||
      this.hsnCode === undefined ||
      this.hsnCode === "undefined"
    ) {
      this.statusText17 = "Please enter HSN Code";
    }
  }

  typeSender() {
    this.senderNameError = "";
    if (
      !this.senderName ||
      this.senderName.contactName == "" ||
      this.senderName.contactName === null ||
      this.senderName.contactName === undefined ||
      this.senderName.contactName === "undefined"
    ) {
      this.senderNameError = "Please Select Sender name";
    }
  }

  orderAmountReq() {
    if (this.paymentMode == "COD" || this.paymentMode == "Prepaid") {
      this.orderAmountError = "";
      if (
        this.orderAmount == "" ||
        this.orderAmount === null ||
        this.orderAmount === undefined ||
        this.orderAmount === "undefined"
      ) {
        this.orderAmountError = "Please enter Amount";
      }
    }
  }

  typeReceiver() {
    this.receiverNameError = "";
    if (
      !this.receiverName ||
      this.receiverName.contactName == "" ||
      this.receiverName.contactName === null ||
      this.receiverName.contactName === undefined ||
      this.receiverName.contactName === "undefined"
    ) {
      this.receiverNameError = "Please enter Receiver name";
    }
  }

  ngOnInit(): void {
    this.numberOfBoxesM = "1";
  }

  nextToShipmentDetails() {
    this.tabClicked = "packageType";
    console.log(this.stockLines);
  }

  nextToPackageType() {
    this.senderNameError = "";
    this.receiverNameError = "";
    this.statusText19 = "";
    this.statusText20 = "";

    if (this.stockLines.length === 0) {
      this.statusText19 = "Please select product";
    }

    for (let r of this.stockLines) {
      if (
        r.actualQuantity === null ||
        r.actualQuantity === undefined ||
        r.actualQuantity <= 0
      ) {
        this.statusText20 = "Please enter quantity as minimum 1";
      }
    }
    if (this.statusText19 != "" || this.statusText20 != "") {
      return false;
    }
    this.tabClicked = "packageType";
    this.defaultValue();
    this.getPackageType();
    this.productConfig = "MULTI_SKU";
    if (this.productConfig == "MULTI_SKU") {
      this.changeBox();
    }
  }

  reviewAndConfirm() {
    this.carrierNameError = "";
    this.shippedDateError = "";
    this.shipmentCostOtherError = "";

    if (this.others == true && !this.carrierName) {
      this.carrierNameError = "please enter carrierName";
    }

    if (this.others == true && !this.shippedDate) {
      this.shippedDateError = "please enter carrierName";
    }

    if (this.others == true && !this.shipmentCostOther) {
      this.shipmentCostOtherError = "please enter carrierName";
    }

    if (
      this.carrierNameError != "" ||
      this.shippedDateError != "" ||
      this.shipmentCostOtherError != ""
    ) {
      return false;
    }

    this.step = 4;
  }

  back() {
    if (this.tabClicked == "packageType") {
      this.tabClicked = "addProducts";
    } else if (this.tabClicked == "payments") {
      this.tabClicked = "packageType";
    } else if (this.tabClicked == "shipping") {
      this.tabClicked = "payments";
    }
  }

  nextToShipping() {
    if (this.productConfig == "SKU") {
      this.shippingOptions1();
    } else if (this.productConfig == "MULTI_SKU") {
      this.shippingOptions2();
    }
    console.log(this.stockLines);
  }

  shippingOptions1() {
    this.statusText25 = "";
    this.statusText26 = "";
    for (let r of this.stockLines) {
      if (r.shipLines === null || r.shipLines === undefined) {
        this.statusText25 =
          "Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing";
      }
    }
    for (let r of this.stockLines) {
      if (r.actualQuantity != r.totalQuantity) {
        this.statusText26 =
          "Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing";
      }
    }
    if (this.statusText25 != "" || this.statusText26 != "") {
      return false;
    }
    this.tabClicked = "payments";
  }

  shippingOptions2() {
    this.statusText27 = "";
    this.statusText28 = "";
    this.stockLines[0].shipLines.forEach((r) => {
      if (!r.packageType) {
        this.statusText27 = "Please select package type";
      }
    });
    this.stockLines.forEach((s) => {
      if (!this.showIcon(s)) {
        this.statusText28 = "Shipment quantity is not matched";
      }
    });
    if (this.statusText27 != "" || this.statusText28 != "") {
      return false;
    }
    this.tabClicked = "payments";
  }

  nextToPayments() {
    if (this.paymentMode == "COD" || this.paymentMode == "Prepaid") {
      this.orderAmountError = "";
      if (
        this.orderAmount == "" ||
        this.orderAmount === null ||
        this.orderAmount === undefined ||
        this.orderAmount === "undefined"
      ) {
        this.orderAmountError = "Please enter Amount";
        return false;
      }
    }
    this.tabClicked = "shipping";
    this.costEstimate();
  }

  clearFields() { }

  draftOrder() { }

  selectShippingInformation() {
    this.step = 1;
    this.tabClicked == "payments";
  }

  addSelectedProduct() {
    if (
      this.activeProduct != null &&
      this.activeProduct.productId !== null &&
      this.activeProduct.productId !== 0
    ) {
      this.stockLine.productId = this.activeProduct.productId;
      this.stockLine.productName = this.activeProduct.productName;
      this.stockLine.sku = this.activeProduct.sku;
      this.stockLine.actualQuantity = this.actualQuantity;
      this.stockLine.shipLines = [
        {
          numberOfBoxes: null,
          quantityPerBox: null,
          productId: this.activeProduct.productId,
          configLineId: this.configLineIdSeq,
          boxHeight: null,
          boxWidth: null,
          boxLength: null,
          boxWeight: null,
          totalQuantity: null,
        },
      ];
      this.stockLines.push(_.cloneDeep(this.stockLine));
      this.activeProduct = null;
      this.actualQuantity = null;
    } else if (
      this.activeProduct != null &&
      this.activeProduct.productId == null
    ) {
      this.newProductPopup = "Y";
      this.activeProduct = null;
      this.actualQuantity = null;
    }
  }

  removeProduct(rp) {
    let index = this.stockLines.indexOf(rp);
    this.stockLines.splice(index, 1);
  }

  populateDimensions(row) {
    if (row.packageType) {
      let index = this.package.findIndex(
        (d) => d.packingType === row.packageType
      );
      if (index > -1) {
        row.boxHeight = this.package[index].height;
        row.boxWidth = this.package[index].width;
        row.boxLength = this.package[index].length;
      }
    }
  }

  addShipmentLine(sl) {
    if (sl === null) {
      return;
    }
    this.statusText21 = "";
    this.statusText22 = "";
    this.statusText23 = "";
    this.statusText24 = "";
    this.statusText25 = "";
    if (sl.qtyPerBoxTmp === null || sl.qtyPerBoxTmp === undefined) {
      this.statusText21 = "Please enter quantity";
    }
    if (sl.numOfBoxesTmp === null || sl.numOfBoxesTmp === undefined) {
      this.statusText22 = "Please enter no.of boxes";
    }
    if (
      sl.boxHeight === null ||
      sl.boxHeight === undefined ||
      sl.boxLength === null ||
      sl.boxLength === undefined ||
      sl.boxWidth === null ||
      sl.boxWidth === undefined
    ) {
      this.statusText23 = "Please enter Dimensions";
    }
    if (sl.boxWeight === null || sl.boxWeight === undefined) {
      this.statusText24 = "Please enter weight";
    }
    if (
      this.statusText21 != "" ||
      this.statusText22 != "" ||
      this.statusText23 != "" ||
      this.statusText24 != ""
    ) {
      return false;
    }
    this.stockShipLines = _.cloneDeep(sl.shipLines);
    if (this.stockShipLines == null) {
      this.stockShipLines = [];
    }
    this.stockShipLine.numberOfBoxes = Number(sl.numOfBoxesTmp);
    this.stockShipLine.quantityPerBox = Number(sl.qtyPerBoxTmp);
    this.stockShipLine.productId = sl.productId;
    this.stockShipLine.configLineId = this.configLineIdSeq;
    this.stockShipLine.packageType = sl.packageType;
    this.stockShipLine.boxHeight = sl.boxHeight;
    this.stockShipLine.boxWidth = sl.boxWidth;
    this.stockShipLine.boxLength = sl.boxLength;
    this.stockShipLine.boxWeight = Number(sl.boxWeight);
    this.stockShipLine.quantityWeight = Number(sl.quantityWeight);
    this.stockShipLine.totalWeight = Number(sl.totalWeight);
    this.stockShipLine.totalPackageWeight = Number(sl.totalPackageWeight);
    this.stockShipLine.totalQuantity = sl.qtyPerBoxTmp * sl.numOfBoxesTmp;
    this.stockShipLines.push(_.cloneDeep(this.stockShipLine));
    sl.shipLines = _.cloneDeep(this.stockShipLines);
    let boxWg = 0;
    sl.shipLines.forEach((ele) => {
      if (ele.quantityPerBox != null && ele.numberOfBoxes != null) {
        boxWg = boxWg + ele.quantityPerBox * ele.numberOfBoxes;
      }
    });
    sl.totalQuantity = boxWg;
    sl.numOfBoxesTmp = null;
    sl.qtyPerBoxTmp = null;
    sl.packageType = undefined;
    sl.boxHeight = null;
    sl.boxWidth = null;
    sl.totalWeight = null;
    sl.boxLength = null;
    sl.boxWeight = null;
    this.stockShipLine = {};
    this.configLineIdSeq = this.configLineIdSeq + 1;
    console.log(sl.shipLines);
  }

  showShipIcon(row) {
    this.statusText14 = "";
    let show = false;
    let totalQuantity = 0;
    totalQuantity =
      totalQuantity + (row.numOfBoxesTmp || 0) * (row.qtyPerBoxTmp || 0);
    row.shipLines.forEach((r) => {
      totalQuantity =
        totalQuantity + (r.quantityPerBox || 0) * (r.numberOfBoxes || 0);
    });
    if (row.actualQuantity == totalQuantity) {
      show = true;
    }
    if (row.actualQuantity != totalQuantity) {
      this.statusText14 =
        "Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing";
      show = false;
    }
    return show;
  }

  showAddShipRow(row) {
    this.statusText14 = "";
    let show = false;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity =
        totalQuantity + (r.quantityPerBox || 0) * (r.numberOfBoxes || 0);
    });
    if (row.actualQuantity == totalQuantity) {
      show = true;
    }
    return show;
  }

  showAddShipmentBtn(row) {
    this.statusText14 = "";
    let show = true;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity =
        totalQuantity + (r.quantityPerBox || 0) * (r.numberOfBoxes || 0);
    });
    if (row.quantity == totalQuantity) {
      show = false;
    }
    totalQuantity =
      totalQuantity + (row.numOfBoxesTmp || 0) * (row.qtyPerBoxTmp || 0);
    if (row.quantity < totalQuantity) {
      this.statusText14 =
        "Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing";
      show = false;
    }
    return show;
  }

  totalWeightCal() {
    this.totalWeight = 0;
    let calQuantityWeight = "";
    if (this.productConfig == "SKU") {
      for (let r of this.stockLines) {
        r.totalWeight =
          (Number(r.boxWeight) || 0) * (Number(r.numOfBoxesTmp) || 0);
        this.totalWeightTemp = r.totalWeight;
        this.totalWeight = this.totalWeight + this.totalWeightTemp;
      }
    } else {
      this.stockLines.forEach((ol) => {
        for (let i = 0; i < ol.shipLines.length; i++) {
          ol.shipLines[i].boxWeight = this.stockLines[0].shipLines[i].boxWeight;
        }
      });
      for (let r of this.stockLines[0].shipLines) {
        this.singleBoxWeightTemp = Number(r.boxWeight) || 0;
        this.totalWeight =
          Number(this.totalWeight) + Number(this.singleBoxWeightTemp);
      }
    }
  }

  openPackage() {
    this.packagesList = this.package;
  }

  removeShipmentLine(r, s) {
    let index = r.shipLines.indexOf(s);
    let lineQuantity = s.quantityPerBox * s.numberOfBoxes;
    r.shipLines.splice(index, 1);
    r.totalQuantity = r.totalQuantity - lineQuantity;
  }

  selectPackType() {
    this.stockLines.forEach((ol) => {
      for (let i = 0; i < ol.shipLines.length; i++) {
        ol.shipLines[i].packageType =
          this.stockLines[0].shipLines[i].packageType;
        ol.shipLines[i].boxLength = this.stockLines[0].shipLines[i].boxLength;
        ol.shipLines[i].boxWidth = this.stockLines[0].shipLines[i].boxWidth;
        ol.shipLines[i].boxHeight = this.stockLines[0].shipLines[i].boxHeight;
      }
    });
  }

  showIcon(row) {
    let show = true;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = Number(totalQuantity) + (Number(r.quantityPerBox) || 0);
    });
    if (Number(row.actualQuantity) != totalQuantity) {
      show = false;
    }
    return show;
  }

  fieldsEntered(row) {
    let show = true;
    let textEntered = false;
    row.shipLines.forEach((r) => {
      if (
        r.quantityPerBox !== "" &&
        r.quantityPerBox !== undefined &&
        r.quantityPerBox
      ) {
        textEntered = true;
      }
    });
    if (!textEntered) {
      show = false;
    }
    return show;
  }

  changeBox() {
    if (this.numberOfBoxesM != "") {
      this.stockLines.forEach((ol) => {
        ol.shipLines = [];
        for (let i = 1; i <= Number(this.numberOfBoxesM); i++) {
          ol.shipLines.push({
            packageType: undefined,
            numberOfBoxes: 1,
            quantityPerBox: 0,
            productId: ol.productId,
            configLineId: this.configLineIdSeq,
            boxHeight: null,
            boxWidth: null,
            boxLength: null,
            boxWeight: null,
            totalWeight: null,
            boxNumber: i,
            totalQuantity: null,
          });
        }
      });
    }
    this.defaultValue();
  }

  change() {
    this.numberOfBoxesM = "1";
    for (let sl of this.stockLines) {
      sl.numOfBoxesTmp = null;
      sl.qtyPerBoxTmp = null;
      sl.boxHeight = null;
      sl.boxWidth = null;
      sl.boxLength = null;
      sl.boxWeight = null;
      sl.totalWeight = null;
      sl.totalQuantity = 0;
      sl.quantityWeight = 0;
      sl.totalWeight = 0;
      sl.packageType = undefined;
      sl.shipLines = [
        {
          numberOfBoxes: null,
          quantityPerBox: null,
          productId: sl.productId,
          configLineId: this.configLineIdSeq,
          boxHeight: null,
          boxWidth: null,
          boxLength: null,
          boxWeight: null,
          totalWeight: null,
          totalQuantity: null,
        },
      ];
    }
  }

  costEstimate() {
    this.stockLines.forEach((ol) => {
      ol.shipLines.forEach((sl) => {
        this.boxHeights =
          this.boxHeights > sl.boxHeight ? this.boxHeights : sl.boxHeight;
        this.boxWidths =
          this.boxWidths > sl.boxWidth ? this.boxWidths : sl.boxWidth;
        this.boxLengths =
          this.boxLengths > sl.boxLength ? this.boxLengths : sl.boxLength;
      });
    });

    let totalBoxes = 0;
    if (this.productConfig == "SKU") {
      for (let stl of this.stockLines) {
        for (let t of stl.shipLines) {
          totalBoxes = Number(totalBoxes) + Number(t.numberOfBoxes || 0);
        }
      }
    } else {
      totalBoxes = Number(this.numberOfBoxesM);
    }
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/costEstimationForShiftAggregator",
        {
          accountOwnerId: this.user.accountOwnerId,
          destPincode: this.contactReceiverZipcode,
          orderType: "PICK",
          totalBoxes: totalBoxes || 0,
          length: this.boxLengths,
          breadth: this.boxWidths,
          height: this.boxHeights,
          paymentMethod: this.paymentMode,
          orderValue: this.orderAmount,
          organizationId: this.user.organizationId,
          originPincode: this.contactSenderZipcode,
          weight: this.totalWeight,
          carrierCode: "ALL",
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.costEstimateList = data;
            this.costEstimation = this.costEstimateList.costEstimateList;
            this.costEstimation.push({
              carrierCode: "Others",
              costEstimates: [
                {
                  id: "",
                  carrierCode: "Others",
                  shippingPreference: "",
                  serviceType: "",
                  totalAmount: null,
                  estimatedDelivery: "",
                  serviceAvailability: "",
                },
              ],
            });

            this.alertService.success(
              "Cost Estimation",
              "Submitted successfully"
            );
          } else {
            this.costEstimateList = data;
            this.costEstimation = this.costEstimateList.costEstimateList;
            this.costEstimation.push({
              carrierCode: "Others",
              costEstimates: [
                {
                  id: "",
                  carrierCode: "Others",
                  shippingPreference: "",
                  serviceType: "",
                  totalAmount: null,
                  estimatedDelivery: "",
                  serviceAvailability: "",
                },
              ],
            });
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  selectCost(c) {
    this.others = false;
    this.othersDisplay = "";
    this.shippingCost = c;
    this.othersDisplay = "";
    if (this.shippingCost.carrierCode == "Others") {
      this.others = true;
      this.othersDisplay = "Others";
    }
  }

  selectOtherCarrier() {
    this.shippingCost = [] || undefined;
  }

  submitCreateStock() {
    if (this.shippingCost.deliveryMode == undefined) {
      this.shipType = this.shippingCost.serviceType;
    } else if (this.shippingCost.serviceType == undefined) {
      this.shipType = this.shippingCost.deliveryMode;
    } else {
      this.shipType = "";
    }
    for (let stl of this.stockLines) {
      for (let i = 0; i < stl.shipLines.length; i++) {
        if (
          !stl.shipLines[i].quantityPerBox ||
          !stl.shipLines[i].numberOfBoxes
        ) {
          stl.shipLines.splice(i, 1);
        }
      }
    }
    let totalBoxes = 0;
    if (this.productConfig == "SKU") {
      for (let stl of this.stockLines) {
        for (let t of stl.shipLines) {
          totalBoxes = Number(totalBoxes) + Number(t.numberOfBoxes || 0);
        }
      }
    } else {
      totalBoxes = Number(this.numberOfBoxesM);
    }
    console.log(this.stockLines);

    /* this.date=this.datePipe.transform(this.shippedDate, 'MM/dd/yyyy'); */

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/createOrderConsignment",
        {
          accountOwnerId: this.user.accountOwnerId,
          organizationId: this.user.organizationId,
          paymentType: this.paymentMode,
          productConfig: this.productConfig,
          receiverId: this.receiverName.accountOwnerContactId,
          senderId: this.senderName.accountOwnerContactId,
          products: this.stockLines,
          senderAddressId: (this.senderName || {}).addressId,
          receiverAddressId: (this.receiverName || {}).addressId,
          refType: "ORDER",
          shipMethod: "PARCEL",
          shipmentPrice:
            this.shippingCost.carrierCode == "Others"
              ? this.shipmentCostOther
              : this.shippingCost.totalAmount,
          shippingType: this.shipType,
          shippingOption:
            this.shippingCost.carrierCode == "Others"
              ? "OTHERS"
              : this.shippingCost.carrierCode,
          totalValue: this.orderAmount,
          status: "SUBMITTED",
          totalBoxes: totalBoxes || 0,
          carrierName: this.carrierName,
          shippedDate: this.datePipe.transform(this.shippedDate, "MM/dd/yyyy"),
          trackingURL: this.trackingURL,
          trackingNumber: this.AWBNumber,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Shipment", "Created Successfully");
            this.router.navigate(["/admin/orders"]);
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  a(b) {
    if (b.packageType == "Custom") {
      this.stockLines.forEach((ol) => {
        for (let i = 0; i < ol.shipLines.length; i++) {
          ol.shipLines[i].boxLength = this.stockLines[0].shipLines[i].boxLength;
          ol.shipLines[i].boxWidth = this.stockLines[0].shipLines[i].boxWidth;
          ol.shipLines[i].boxHeight = this.stockLines[0].shipLines[i].boxHeight;
        }
      });
    }
  }

  cancelPopup() {
    this.newSenderPopup = "N";
    this.newReceiverPopup = "N";
    this.creditBalancePopup = "N";
    this.newProductPopup = "N";
    this.senderMobile = "";
    this.senderContactName = "";
    this.senderEmail = "";
    this.receiverContactName = "";
    this.receiverEmail = "";
    this.amount = "";
    this.receiverMobile = "";
    this.address.address1 = "";
    this.address.city = "";
    this.address.state = "";
    this.address.zip = "";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";
    this.statusText12 = "";
    this.statusText13 = "";
    this.statusText14 = "";
    this.statusText30 = "";
  }

  getSenderAddress() {
    this.g.loaderDisplay = "display";
    this.api
      .getAddressByAddressId(
        (this.senderName || {}).addressId,
        this.user.organizationId
      )
      .subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          this.senderNameAddressText = data.addressText;
          this.contactSenderZipcode = data.zipcode;
        },
        (err) => {
          this.alertService.error("Error", err);
          this.g.loaderDisplay = "";
        }
      );
  }

  getReceiverAddress() {
    this.g.loaderDisplay = "display";
    this.api
      .getAddressByAddressId(
        (this.receiverName || {}).addressId,
        this.user.organizationId
      )
      .subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          this.receiverNameAddressText = data.addressText;
          this.contactReceiverZipcode = data.zipcode;
        },
        (err) => {
          this.alertService.error("Error", err);
          this.g.loaderDisplay = "";
        }
      );
  }

  addReceiver() {
    this.receiverNameError = "";
    this.newReceiverPopup = "Y";
    this.stateList();
    this.cityList();
  }

  addSender() {
    this.senderNameError = "";
    this.newSenderPopup = "Y";
    this.stateList();
    this.cityList();
  }

  addNewProduct() {
    this.newProductPopup = "Y";
    this.productName = "";
    this.sku = "";
    this.hsnCode = "";
    this.price = "";
    this.taxRate = "";
    this.dimensions = "";
    this.weight = 0;
  }

  selectProduct() {
    this.statusText2 = "";
    if (
      !this.activeProduct ||
      this.activeProduct.productName == "" ||
      this.activeProduct.productName === null ||
      this.activeProduct.productName === undefined ||
      this.activeProduct.productName === "undefined"
    ) {
      this.statusText20 = "Please select product";
    }
  }

  copied(event) {
    if (event.isSuccess) {
      this.alertService.success(event.content, "Copied Successfully");
    }
  }

  open() {
    this.selectedProducts = _.cloneDeep(this.activeProducts);
    for (let i = 0; i < this.stockLines.length; i++) {
      let index = this.selectedProducts.findIndex(
        (d) => d.productName === this.stockLines[i].productName
      );
      if (index > -1) {
        this.selectedProducts.splice(index, 1);
      }
    }
  }

  productSearch(term: string, item: any = []) {
    term = term.toLowerCase();
    return (
      item.productName.toLowerCase().indexOf(term) > -1 ||
      (item.sku && item.sku.toLowerCase().indexOf(term) > -1)
    );
  }

  submitSender() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    if (
      this.senderContactName == "" ||
      this.senderContactName === null ||
      this.senderContactName === undefined ||
      this.senderContactName === "undefined"
    ) {
      this.statusText1 = "Please enter Sender name";
    }
    if (
      this.senderEmail == "" ||
      this.senderEmail === null ||
      this.senderEmail === undefined ||
      this.senderEmail === "undefined"
    ) {
      this.statusText2 = "Please enter Sender Email";
    }
    if (
      this.senderMobile == "" ||
      this.senderMobile === null ||
      this.senderMobile === undefined ||
      this.senderMobile === "undefined"
    ) {
      this.statusText3 = "Please enter Sender Mobile number";
    }
    if (
      this.address.address1 == "" ||
      this.address.address1 === null ||
      this.address.address1 === undefined ||
      this.address.address1 === "undefined"
    ) {
      this.statusText4 = "Please enter Sender Address1";
    }
    if (
      this.address.city == "" ||
      this.address.city === null ||
      this.address.city === undefined ||
      this.address.city === "undefined"
    ) {
      this.statusText5 = "Please enter Sender City";
    }
    if (
      this.address.state == "" ||
      this.address.state === null ||
      this.address.state === undefined ||
      this.address.state === "undefined"
    ) {
      this.statusText6 = "Please enter Sender State";
    }
    if (
      this.address.zip == "" ||
      this.address.zip === null ||
      this.address.zip === undefined ||
      this.address.zip === "undefined"
    ) {
      this.statusText7 = "Please enter Sender Zip";
    }
    if (
      this.statusText1 != "" ||
      this.statusText2 != "" ||
      this.statusText3 != "" ||
      this.statusText4 != "" ||
      this.statusText5 != "" ||
      this.statusText6 != "" ||
      this.statusText7 != ""
    ) {
      return false;
    }
    this.senderAddresses.push(this.address);
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/createAccountOwnerContacts",
        {
          accountOwnerId: this.user.accountOwnerId,
          mobile: this.senderMobile,
          addresses: this.senderAddresses,
          companyName: this.senderCompanyName,
          contactName: this.senderContactName,
          email: this.senderEmail,
          status: "ACTIVE",
          source: "SHIFT",
          customerType: "SENDER",
          organizationId: 1,
        },
        { headers: header1 }
      )
      .subscribe(
        (data: Contacts) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Contact", "Created Successfully");
            this.cancelPopup();
            this.contactSender.push(data);
            let newpack = [...this.contactSender];
            this.contactSender = [];
            this.contactSender = newpack;
            this.senderName = data;
            console.log((this.senderName || {}).addressId);
            alert((this.senderName || {}).addressId);
            if((this.senderName || {}).addressId != undefined || (this.senderName || {}).addressId != null){
              this.getSenderAddress();
            }
          } else {
            this.alertService.error("Error", data["message"]);
          }
          this.g.loaderDisplay = "";
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        }
      );
  }

  submitReceiver() {
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";
    this.statusText12 = "";
    this.statusText13 = "";
    this.statusText14 = "";
    if (
      this.receiverContactName == "" ||
      this.receiverContactName === null ||
      this.receiverContactName === undefined ||
      this.receiverContactName === "undefined"
    ) {
      this.statusText8 = "Please enter Receiver name";
    }
    if (
      this.receiverEmail == "" ||
      this.receiverEmail === null ||
      this.receiverEmail === undefined ||
      this.receiverEmail === "undefined"
    ) {
      this.statusText9 = "Please enter Receiver Email";
    }
    if (
      this.receiverMobile == "" ||
      this.receiverMobile === null ||
      this.receiverMobile === undefined ||
      this.receiverMobile === "undefined"
    ) {
      this.statusText10 = "Please enter Receiver Mobile number";
    }
    if (
      this.address.address1 == "" ||
      this.address.address1 === null ||
      this.address.address1 === undefined ||
      this.address.address1 === "undefined"
    ) {
      this.statusText11 = "Please enter Receiver Address1";
    }
    if (
      this.address.city == "" ||
      this.address.city === null ||
      this.address.city === undefined ||
      this.address.city === "undefined"
    ) {
      this.statusText12 = "Please enter Receiver City";
    }
    if (
      this.address.state == "" ||
      this.address.state === null ||
      this.address.state === undefined ||
      this.address.state === "undefined"
    ) {
      this.statusText13 = "Please enter Receiver State";
    }
    if (
      this.address.zip == "" ||
      this.address.zip === null ||
      this.address.zip === undefined ||
      this.address.zip === "undefined"
    ) {
      this.statusText14 = "Please enter Receiver Zip";
    }
    if (
      this.statusText8 != "" ||
      this.statusText9 != "" ||
      this.statusText10 != "" ||
      this.statusText11 != "" ||
      this.statusText12 != "" ||
      this.statusText13 != "" ||
      this.statusText14 != ""
    ) {
      return false;
    }
    this.receiverAddresses.push(this.address);
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/createAccountOwnerContacts",
        {
          accountOwnerId: this.user.accountOwnerId,
          mobile: this.receiverMobile,
          addresses: this.receiverAddresses,
          companyName: this.receiverCompanyName,
          contactName: this.receiverContactName,
          email: this.receiverEmail,
          status: "ACTIVE",
          source: "SHIFT",
          customerType: "RECEIVER",
          organizationId: 1,
        },
        { headers: header1 }
      )
      .subscribe(
        (data: Contacts) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Contact", "Created Successfully");
            this.cancelPopup();
            this.contactReceiver.push(data);
            let newpack = [...this.contactReceiver];
            this.contactReceiver = [];
            this.contactReceiver = newpack;
            this.receiverName = data;
            if((this.receiverName || {}).addressId != undefined || (this.receiverName || {}).addressId != null){
              this.getReceiverAddress();
            }
          } else {
            this.alertService.error("Error", data["message"]);
          }
          this.g.loaderDisplay = "";
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        }
      );
  }

  skuValue() {
    this.sku = "SFT" + this.storeSku + this.user.accountOwnerId;
  }

  validateSenderEmail() {
    this.statusText2 = "";
    this.typeSenderEmail();
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    this.http
      .post(environment.apiUrl + "api/uniqueEmail?email=" + this.senderEmail + '&userType=' + 'SENDER', {
        headers: header1,
      })
      .subscribe(
        (data) => {
          if (data["code"] == 200) {
            this.g.loaderDisplay = "";
          } else {
            if (data["code"] == 400) {
              this.statusText2 = data["message"];
              this.g.loaderDisplay = "";
            }
            this.g.loaderDisplay = "";
          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.statusText2 = "uniqueEmail Failed, please re-try.";
        }
      );
  }

  validateReceiverEmail() {
    this.statusText9 = "";
    this.typeReceiverEmail();
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    this.http
      .post(environment.apiUrl + "api/uniqueEmail?email=" + this.receiverEmail + '&userType=' + 'RECEIVER', {
        headers: header1,
      })
      .subscribe(
        (data) => {
          if (data["code"] == 200) {
            this.g.loaderDisplay = "";
          } else {
            if (data["code"] == 400) {
              this.statusText9 = data["message"];
              this.g.loaderDisplay = "";
            }
            this.g.loaderDisplay = "";
          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.statusText9 = "uniqueEmail Failed, please re-try.";
        }
      );
  }

  submitCreateProduct() {
    this.g.loaderDisplay = "display";
    this.statusText15 = "";
    this.statusText16 = "";
    this.statusText17 = "";

    if (
      this.productName == "" ||
      this.productName === null ||
      this.productName === undefined ||
      this.productName === "undefined"
    ) {
      this.statusText15 = "Please enter Product Name";
    }
    if (
      this.hsnCode == "" ||
      this.hsnCode === null ||
      this.hsnCode === undefined ||
      this.hsnCode === "undefined"
    ) {
      this.statusText17 = "Please enter HSN Code";
    }

    if (
      this.storeSku == "" ||
      this.storeSku === null ||
      this.storeSku === undefined ||
      this.storeSku === "undefined"
    ) {
      this.statusText16 = "Please enter Store SKU";
    } else if (this.storeSku.length <= 3) {
      this.statusText16 = "Store SKU must contain atleast 3-50 characters";
    }

    if (
      this.statusText15 != "" ||
      this.statusText16 != "" ||
      this.statusText17 != ""
    ) {
      this.g.loaderDisplay = "";
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/createProduct",
        {
          accountOwnerId: this.user.accountOwnerId || this.accountOwner,
          organizationId: 1,
          dimensions: this.productLength + "*" + this.productWidth + "*" + this.productHeight,
          productName: this.productName,
          productType: "Regular",
          sku: this.sku,
          status: "ACTIVE",
          storeSku: this.storeSku,
          weight: this.weight,
          hsnCode: this.hsnCode,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == "200") {
            this.alertService.success("Product", "Created Successfully");
            this.activeProduct = data;
            this.activeProducts.push(this.activeProduct);
            this.addSelectedProduct();
            this.getProducts();
            this.newProductPopup = "N";
          } else if (data["code"] == "400") {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  addNewLine() {
    if (this.actualQuantity > 0) {
      this.addSelectedProduct();
    }
  }

  defaultValue() {
    for (let r of this.stockLines) {
      if (r.actualQuantity == 1) {
        for (let b of r.shipLines) {
          b.quantityPerBox = r.actualQuantity;
        }
      }
    }
  }

  textValues() {
    this.open();
    if (this.textVal) {
      this.setOfValues = this.textVal.split(",");
      for (let a of this.setOfValues) {
        for (let sp of this.selectedProducts) {
          if (sp.storeSku == a) {
            this.stockLine.productId = sp.productId;
            this.stockLine.productName = sp.productName;
            this.stockLine.sku = sp.sku;
            this.stockLine.storeSku = sp.storeSku;
            this.stockLine.actualQuantity = this.actualQuantity;
            this.stockLine.shipLines = [
              {
                numberOfBoxes: null,
                quantityPerBox: null,
                productId: this.activeProduct.productId,
                configLineId: this.configLineIdSeq,
                boxHeight: null,
                boxWidth: null,
                boxLength: null,
                boxWeight: null,
                totalQuantity: null,
              },
            ];
            this.stockLines.push(_.cloneDeep(this.stockLine));
          }
        }
      }
    }
  }

  getCreditAmount() {
    this.statusText30 = "";
    this.api
      .getCreditTransactionAmount()
      .subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          this.getCreditsAmount = data;
          if (this.getCreditsAmount > 500) {
            this.submitCreateStock();
          } else {
            this.statusText30 = "Minimum credit balance of ₹500 required";
          }
        },
        (err) => {
          this.alertService.error("Error", err);
        }
      );
  }

  addCreditBalPopup() {
    this.creditBalancePopup = "Y";
  }

  typeAmount() {
    if (
      this.amount == "" ||
      this.amount === null ||
      this.amount === undefined ||
      this.amount === "undefined"
    ) {
      this.amountError = "Please enter Amount";
    }
  }

  submitCreditBal() {
    if (
      this.amount == "" ||
      this.amount === null ||
      this.amount === undefined ||
      this.amount === "undefined"
    ) {
      this.amountError = "Please enter Amount";
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl +
        "api/paymentForCODOrderInRazorPay?accountOwnerId=" +
        this.user.accountOwnerId +
        "&amount=" +
        this.amount,
        null,
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          this.razorPayData = data;
          if (data["code"] == 200) {
            this.alertService.success("orderId", data["message"]);
            this.razorPayData = data;
            let options: any = {
              key: environment.razorPayKey, // Enter the Key ID generated from the Dashboard
              amount: this.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
              currency: "INR",
              image: "https://example.com/your_logo",
              order_id: this.razorPayData.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1,
              theme: {
                color: "#3399cc",
              },
            };
            options.handler = (response: any, error: any) => {
              options.response = response;
              console.log("response::" + response);
              this.updateSuccessfulPayment(response);
            };

            const rzp1 = new this.payService.nativeWindow.Razorpay(options);
            rzp1.open();
            rzp1.on("payment.failed", (response: any) => {
              this.updateFailurePayment(response);
            });
          } else {
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  updateSuccessfulPayment(response) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updateCreditTransactionForRazorPay",
        {
          razorPayOrderId: response.razorpay_order_id,
          razorPayPaymentId: response.razorpay_payment_id,
          razorPaySignature: response.razorpay_signature,
          response: "SUCCESS",
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.cancelPopup();
            this.alertService.success("Payment Success", data["message"]);
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  updateFailurePayment(response) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updateCreditTransactionForRazorPay",
        {
          errorCode: response.error.code,
          errorDescription: response.error.description,
          errorSource: response.error.source,
          errorReason: response.error.reason,
          errorStep: response.error.step,
          razorPayOrderId: response.error.metadata.order_id,
          razorPayPaymentId: response.error.metadata.payment_id,
          response: "FAILURE",
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.cancelPopup();
            this.alertService.success("Payment Failed", data["message"]);
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }
}
